import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';

export const Map =() =>{

	return (
      <Container fluid id="equipo" style={{background:'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(/assets/images/Start2.png)', backgroundSize: 'cover'}} className="fablab-container">
        <Container className="fablab-container" id="ubicacion">
          <Row>
            <Col>
              <h1 className="fablab-title white">Ubicación</h1>
              <h2 className="fablab-subtitle white text-center">Estamos ubicados en el edificio C del campus San Joaquín de la Universidad Técnica Federico Santa María</h2>
            </Col>
            <Col className="text-center d-block d-md-none" xs="12">
              <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="https://goo.gl/maps/kX7UydLCR2nWfUxW8">Más información <FontAwesomeIcon className="fablab-button-circle white" icon={faArrowRight}/></a>
            </Col>
          </Row>

          <Container className="super-iframe-holder d-none d-md-block">
            <iframe title="Map" border="none" frameBorder="0" scrolling="auto" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d831.8486974701766!2d-70.61899112129238!3d-33.4911043201137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d124540ba5d5%3A0x776951cec4a5bedb!2sFabLab%20UTFSM!5e0!3m2!1ses-419!2scl!4v1619560306621!5m2!1ses-419!2scl">Este navegador no es compatible con iframes</iframe>
          </Container>
        </Container>
    </Container>
	)
}